import { createContext, type RefObject, useContext } from "react";

/** Interface */
interface ITabsContext {
	tabsId: string;
	headerRef: RefObject<HTMLDivElement | null>;
}

/** Context */
export const TabsContext = createContext<ITabsContext>({} as ITabsContext);

/** Hooks */
export function useTabsContext() {
	return useContext(TabsContext);
}
